import React from 'react'
import { Switch } from 'react-router-dom'

export default class AnimatedSwitch extends Switch {
  style = {
    position: 'absolute',
    left: 0,
    right: 0,
    width: '100vw',
    opacity: 0,
    transform: 'translateY(-30px)',
    transition:
      'transform 0.3s cubic-bezier(0.4, 0.0, 0.2, 1), opacity 0.3s cubic-bezier(0.4, 0.0, 0.2, 1)',
    willChange: 'transform, opacity',
  }
  constructor(props) {
    super(props)
    this.containerRef = React.createRef()
  }

  componentWillAppear(cb) {
    setTimeout(() => {
      this.containerRef.current.style.position = 'absolute'
      this.containerRef.current.style.transform = 'translateY(0px)'
      this.containerRef.current.style.opacity = '1'
      setTimeout(() => {
        this.containerRef.current.style.position = 'relative'
        cb()
      }, 350)
    }, 300)
  }
  componentWillEnter(cb) {
    // this.props.children.map(
    //   // how to access animation data from component
    //   child => {
    //     if (child.props.component.testData) {
    //       console.log(child.props.component.testData)
    //     }
    //   },
    // )
    setTimeout(() => {
      this.containerRef.current.style.position = 'absolute'
      this.containerRef.current.style.transform = 'translateY(0px)'
      this.containerRef.current.style.opacity = '1'
      setTimeout(() => {
        // this.scrollToTop()
        this.containerRef.current.style.position = 'relative'
        cb()
      }, 300)
    }, 600)
  }
  componentWillLeave(cb) {
    this.containerRef.current.style.position = 'absolute'
    this.containerRef.current.style.transform = 'translateY(-30px)'
    this.containerRef.current.style.opacity = '0'
    setTimeout(() => {
      this.containerRef.current.style.position = 'relative'
      cb()
    }, 300)
  }
  scrollToTop = () => {
    const c = document.documentElement.scrollTop || document.body.scrollTop
    if (c > 0) {
      window.requestAnimationFrame(this.scrollToTop)
      window.scrollTo(0, c - c / 4)
    }
  }
  render() {
    return (
      <div
        ref={this.containerRef}
        style={{
          ...this.style,
        }}
      >
        {super.render()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/common/AnimatedSwitch/index.js